import * as yup from "yup";

const deleteSchema = (translate: Function) => yup.object().shape({
	efa002Fantasia: yup.string().required(translate("Nome da empresa não confere")).oneOf([yup.ref("efa002FantasiaConfirmation")], translate("Nome da empresa não confere"))
});

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	efa002Razao: yup.string().required(translate("Razão social é requerido")),
	efa002Fantasia: yup.string().required(translate("Nome fantasia é requerido")),
	efa002Cnpj:  yup.string().required(translate("CNPJ é requerido")),
	efa002Ativo: yup.boolean(),
	efa002Uf: yup.string().required(translate("UF é requerido"))
});

export { deleteSchema, addAndChangeSchema };
